// Responsive ad placement
var adMoved = false;
var ad = document.querySelector('.ad');
var initialParent = ad === null || ad === void 0 ? void 0 : ad.parentElement;
var adTargetContainer = document.querySelector('.ad-mobile-container');
var moveAd = function () {
    if (!ad || !adTargetContainer || !initialParent) {
        return;
    }
    var query = window.matchMedia('(max-width: 1023px');
    if (!query.matches) {
        if (adMoved) {
            initialParent.prepend(ad);
        }
        return;
    }
    adMoved = true;
    ad.remove();
    document.querySelector('.ad-mobile-container p:nth-child(2)').prepend(ad);
};
window.addEventListener('resize', function () { return moveAd(); });
moveAd();
// Responsive iframes
document.querySelectorAll('.kg-card iframe').forEach(function (elem) { return elem.parentElement.classList.add('embed-iframe-container'); });
// Mobile menu toggle
var toggleButton = document.querySelector('#toggle-menu');
toggleButton.addEventListener('click', function () {
    var menu = document.querySelector('#menu');
    var menuContainer = document.querySelector('#menu-container');
    if (!menu || !menuContainer) {
        return;
    }
    toggleButton.classList.toggle('change');
    menuContainer.classList.toggle('bg-gray-800');
    document.querySelectorAll('.responsive-menu').forEach(function (e) { return e.classList.toggle('hidden'); });
});
